import { Link, useLocation } from "react-router-dom";
import logo from "../../images/logo.png";
import { cn } from "../../lib/utils";
import React from "react";
import { useAuth } from "../../lib/AuthContext";

interface MainNavProps extends React.HTMLAttributes<HTMLElement> {
  onLinkClick?: () => void;
}

export default function MainNav({
  className,
  onLinkClick,
  ...props
}: MainNavProps) {
  const location = useLocation();
  const auth = useAuth();
  const hasCRM = auth?.currentUser?.module_crm_plan;
  const flags = auth.featureFlags;
  console.log("Feature flags:", flags);
  console.log("Has CRM:", hasCRM);
  console.log(
    "Is commission tracking allowed:",
    flags.includes("commission_tracking")
  );
  const isAllowed = (flag: string) => flags.includes(flag);

  const handleLinkClick = () => {
    if (onLinkClick) {
      onLinkClick();
    }
  };

  // Check if this is mobile menu (flex-col class indicates mobile)
  const isMobileMenu = className?.includes("flex-col");

  // Helper function to get mobile menu link classes
  const getMobileLinkClasses = (pathname: string) => {
    if (!isMobileMenu) return "";
    return cn(
      "w-full px-4 py-3 text-left border-b border-gray-200 hover:bg-gray-50 flex items-center",
      location.pathname === pathname && "bg-gray-50 text-primary"
    );
  };

  return (
    <nav
      className={cn("flex items-center space-x-4 lg:space-x-6", className)}
      {...props}
    >
      {/* Logo - only visible on desktop */}
      <Link to="/" className="hidden lg:block">
        <img src={logo} alt="logo" width="50" height="50" />
      </Link>
      <Link
        to="/"
        onClick={handleLinkClick}
        className={cn(
          "text-sm font-medium text-muted-foregorund hover:text-primary dashboard-link",
          location.pathname === "/" ? "text-primary" : "",
          getMobileLinkClasses("/")
        )}
        id="dashboard-link"
      >
        Dashboard
      </Link>
      {isAllowed("calendar") && (
        <Link
          to="/calendar/"
          onClick={handleLinkClick}
          className={cn(
            "text-sm font-medium text-muted-foregorund hover:text-primary calendar-link",
            location.pathname === "/calendar/" ? "text-primary" : "",
            getMobileLinkClasses("/calendar/")
          )}
          id="calendar-link"
        >
          Calendar
        </Link>
      )}
      <Link
        to="/clients/"
        onClick={handleLinkClick}
        className={cn(
          "text-sm font-medium text-muted-foregorund hover:text-primary clients-link",
          location.pathname === "/clients/" ? "text-primary" : "",
          getMobileLinkClasses("/clients/")
        )}
        id="clients-link"
      >
        Clients
      </Link>
      {isAllowed("performance") && hasCRM && (
        <Link
          to="/agency-performance/"
          onClick={handleLinkClick}
          className={cn(
            "text-sm font-medium text-muted-foregorund hover:text-primary sales-link",
            location.pathname === "/agency-performance/" ? "text-primary" : "",
            getMobileLinkClasses("/agency-performance/")
          )}
          id="agency-performance-link"
        >
          Agency Performance
        </Link>
      )}
      {isAllowed("sales") && hasCRM && (
        <Link
          to="/sales/"
          onClick={handleLinkClick}
          className={cn(
            "text-sm font-medium text-muted-foregorund hover:text-primary sales-link",
            location.pathname === "/sales/" ? "text-primary" : "",
            getMobileLinkClasses("/sales/")
          )}
          id="sales-link"
        >
          Sales
        </Link>
      )}
      {isAllowed("commission_tracking") && hasCRM && (
        <Link
          to="/commission-tracking/"
          onClick={handleLinkClick}
          className={cn(
            "text-sm font-medium text-muted-foregorund hover:text-primary commission-tracking-link",
            location.pathname === "/commission-tracking/" ? "text-primary" : "",
            getMobileLinkClasses("/commission-tracking/")
          )}
          id="commission-tracking-link"
        >
          Commission Tracking
        </Link>
      )}
      {isAllowed("knowledge_base") && (
        <Link
          to="/knowledge-base/"
          onClick={handleLinkClick}
          className={cn(
            "text-sm font-medium text-muted-foregorund hover:text-primary",
            location.pathname === "/knowledge-base/" ? "text-primary" : "",
            getMobileLinkClasses("/knowledge-base/")
          )}
          id="knowledge-base-link"
        >
          Knowledge Base
        </Link>
      )}
      <Link
        to="/feedback/"
        onClick={handleLinkClick}
        className={cn(
          "text-sm font-medium text-muted-foregorund hover:text-primary feedback-link",
          location.pathname === "/feedback/" ? "text-primary" : "",
          getMobileLinkClasses("/feedback/")
        )}
        id="feedback-link"
      >
        Feedback
      </Link>{" "}
    </nav>
  );
}
